import { Component } from 'react';
import classNames from 'classnames';
import transLoader from '@beisen/i18n-translation-loader';
require('./SortList.scss');

const defaultTranslation = {
    asc: '升序',
    desc: '降序',
    defaultSort: '默认排序'
};
export default class SortList extends Component {
	constructor(props) {
		super(props);
		this.stopTap = this.stopTap.bind(this);
        this.touchCancle = this.touchCancle.bind(this);
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            asc: 'toolsBar.asc',
            desc: 'toolsBar.desc',
            defaultSort: 'toolsBar.defaultSort'
        }), props.translation);
	}

	selectItem(field, name, dir, e) {
		e.preventDefault();
		e.persist();
		let { selectFields } = this.props;
		if(e.target.className.indexOf('active') > 0) {
			selectFields && selectFields([]);
		}else{
			selectFields && selectFields([{
				sort_column: field
				,sort_dir: dir
				,sort_name: name
			}]);
		}
		this.props.handleClosePopUp && this.props.handleClosePopUp();
	}

	touchCancle() {
		this.props.handleClosePopUp();
	}

	stopTap(e) {
		e.preventDefault();
		e.stopPropagation();
	}

	getSortList() {
        const { translation } = this;
		let { sortFields, activeFields = [] } = this.props;

		if(activeFields[0]) {
			for (let i =  0; i < sortFields.length; i++) {
				if(sortFields[i].sortField == activeFields[0].sort_column) {
					sortFields[i].itemActive = true;
					if(activeFields[0].sort_dir == 'asc') {
						sortFields[i].ascActive = true;
					}else if(activeFields[0].sort_dir == 'desc') {
						sortFields[i].descActive = true;
					}
					break;
				}
			}
		}

		return sortFields.map((data,index) => {
			let titleCls = classNames('sort-title' ,{ 'active': data.itemActive });
			return (
				<li className='sort-item border-1px border-b' key={index}>
					<div className={titleCls}> {data.title} </div>
					<div className='sort-button'>
						<div className='sort-group'>
							<span className={classNames('sort-asc',{ 'active': data.ascActive })}
								  onTouchTap={this.selectItem.bind(this,data.sortField,data.name,'asc')}>
								{translation.asc}
							</span>

							<span className={classNames('sort-desc',{ 'active': data.descActive })}
								  onTouchTap={ this.selectItem.bind(this,data.sortField,data.name,'desc')}>
								{translation.desc}
							</span>
						</div>
					</div>
				</li>
			);
		});
	}

	render() {
        const { translation } = this;
		const hasDefaultSort = this.props.defaultSort[0] ? this.selectItem.bind(this,this.props.defaultSort[0].sort_column,this.props.defaultSort[0].sort_name,this.props.defaultSort[0].sort_dir) : this.touchCancle;
		return (
			<ul className='sort-list' onTouchTap={this.stopTap}>
				<li className='sort-item border-1px border-b'
				    onTouchTap={hasDefaultSort}
				>
				    <div className='sort-title'>{translation.defaultSort}</div>
					<div className='sort-moren'>{translation.defaultSort}</div>
				</li>

				{this.getSortList()}
			</ul>
			);
	}
}



// WEBPACK FOOTER //
// ./src/components/List/SortList.js